import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function NotFound() {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col items-center justify-center px-8">
      <div className="text-center max-w-md">
        <div className="text-8xl font-black text-green-500 mb-4">404</div>
        <h1 className="text-3xl font-black uppercase tracking-tight mb-4">
          Page Not Found
        </h1>
        <p className="text-gray-500 text-sm leading-relaxed mb-8">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to={user ? '/dashboard' : '/'}
          className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors"
        >
          {user ? 'Back to Dashboard' : 'Back to Home'}
        </Link>
      </div>
    </div>
  )
}